// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: 'https://modelling.staging.netpurpose.com' | (string & {});
};

/**
 * ActivityBase
 */
export type ActivityBase = {
    /**
     * Activity Id
     */
    activity_id: string;
    /**
     * Activity Name
     */
    activity_name: string;
    /**
     * Baseline
     */
    baseline?: boolean;
    /**
     * Taxon Id
     */
    taxon_id: number;
    /**
     * Reporting Standards
     */
    reporting_standards?: Array<ReportingStandard> | null;
};

/**
 * ActivityMinimalResponse
 */
export type ActivityMinimalResponse = {
    /**
     * Activity Id
     */
    activity_id: string;
    /**
     * Activity Name
     */
    activity_name: string;
};

/**
 * ActivitySummary
 */
export type ActivitySummary = {
    /**
     * Activity Id
     */
    activity_id: string;
    /**
     * Activity Name
     */
    activity_name: string;
    /**
     * Theme
     */
    theme: string;
    /**
     * Sub Theme
     */
    sub_theme: string;
    /**
     * Domain
     */
    domain: string;
    /**
     * Baseline
     */
    baseline: boolean;
    /**
     * Accepted Costs
     */
    accepted_costs: number;
    /**
     * Total Costs
     */
    total_costs: number;
    /**
     * All Accepted
     */
    all_accepted: string;
    /**
     * Taxon Id
     */
    taxon_id: number;
    /**
     * Parent Id
     */
    parent_id: number;
    /**
     * Sub Theme Taxon Id
     */
    sub_theme_taxon_id: number;
};

/**
 * ActivityTaxonResponse
 */
export type ActivityTaxonResponse = {
    /**
     * Reporting Standards
     */
    reporting_standards?: Array<ReportingStandard> | null;
    /**
     * Primary Reporting Standard Id
     */
    primary_reporting_standard_id?: number | null;
    /**
     * Theme
     */
    theme: string;
    /**
     * Sub Theme
     */
    sub_theme?: string | null;
    /**
     * Domain
     */
    domain?: string | null;
    /**
     * Type
     */
    type: string;
    /**
     * Name
     */
    name: string;
    /**
     * Parent Id
     */
    parent_id?: number | null;
    /**
     * Taxon Id
     */
    taxon_id: number;
    /**
     * Is Complete
     */
    is_complete?: boolean | null;
    sdg_alignment_type: SdgAlignmentType;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Keywords
     */
    keywords?: Array<string> | null;
    /**
     * Exclude From Revenue Segments
     */
    exclude_from_revenue_segments: boolean;
    /**
     * Activity Id
     */
    activity_id: string;
    /**
     * Is Baseline
     */
    is_baseline: boolean;
};

/**
 * BaseQuestionDetails
 */
export type BaseQuestionDetails = {
    /**
     * Question Id
     */
    question_id: number;
    /**
     * Question Name
     */
    question_name: string;
    /**
     * Sdgs
     */
    sdgs?: Array<number> | null;
};

/**
 * BranchedDatapoint
 *
 * Datapoint with information regarding it's branching status
 */
export type BranchedDatapoint = {
    impact_theme?: ImpactThemes | null;
    /**
     * Datapoint Id
     */
    datapoint_id?: string | null;
    type?: DatapointTypes;
    /**
     * Original Workbook Id
     */
    original_workbook_id?: number | null;
    /**
     * Reported Value
     */
    reported_value?: number | null;
    /**
     * Value
     */
    value: number;
    /**
     * Unit Id
     */
    unit_id: number;
    /**
     * Reported Unit Id
     */
    reported_unit_id?: number | null;
    /**
     * Formula
     */
    formula?: string | null;
    /**
     * Raw
     */
    raw?: boolean;
    /**
     * Reference
     */
    reference?: Reference | CreateReference | null;
    /**
     * Reporting End Date
     */
    reporting_end_date?: string | null;
    /**
     * Assigned Year
     */
    assigned_year?: number | null;
    status?: DatapointStatus | null;
    /**
     * Fx Rate Used
     */
    fx_rate_used?: number | null;
    /**
     * Fx Rate Date
     */
    fx_rate_date?: string | null;
    /**
     * Question Id
     */
    question_id: number;
};

/**
 * BranchedMacroFactor
 *
 * MacroFactor with information regarding it's branching status
 */
export type BranchedMacroFactor = {
    impact_theme?: ImpactThemes | null;
    /**
     * Datapoint Id
     */
    datapoint_id?: string | null;
    type?: DatapointTypes;
    /**
     * Original Workbook Id
     */
    original_workbook_id?: number | null;
    /**
     * Reported Value
     */
    reported_value?: number | null;
    /**
     * Value
     */
    value: number;
    /**
     * Unit Id
     */
    unit_id: number;
    /**
     * Reported Unit Id
     */
    reported_unit_id?: number | null;
    /**
     * Formula
     */
    formula?: string | null;
    /**
     * Raw
     */
    raw?: boolean;
    /**
     * Reference
     */
    reference?: Reference | CreateReference | null;
    /**
     * Reporting End Date
     */
    reporting_end_date?: string | null;
    /**
     * Assigned Year
     */
    assigned_year?: number | null;
    status?: DatapointStatus | null;
    /**
     * Fx Rate Used
     */
    fx_rate_used?: number | null;
    /**
     * Fx Rate Date
     */
    fx_rate_date?: string | null;
    /**
     * Question Id
     */
    question_id: number;
    /**
     * Taxon Id
     */
    taxon_id?: number | null;
    /**
     * Theme
     */
    theme?: string | null;
    /**
     * Macro Factor Name
     */
    macro_factor_name: string;
};

/**
 * BranchedTechnologyCost
 *
 * TechnologyCost with information about branching status
 */
export type BranchedTechnologyCost = {
    impact_theme?: ImpactThemes | null;
    /**
     * Datapoint Id
     */
    datapoint_id?: string | null;
    type?: DatapointTypes;
    /**
     * Original Workbook Id
     */
    original_workbook_id?: number | null;
    /**
     * Reported Value
     */
    reported_value?: number | null;
    /**
     * Value
     */
    value: number;
    /**
     * Unit Id
     */
    unit_id: number;
    /**
     * Reported Unit Id
     */
    reported_unit_id?: number | null;
    /**
     * Formula
     */
    formula?: string | null;
    /**
     * Raw
     */
    raw?: boolean;
    /**
     * Reference
     */
    reference?: Reference | CreateReference | null;
    /**
     * Reporting End Date
     */
    reporting_end_date?: string | null;
    /**
     * Assigned Year
     */
    assigned_year?: number | null;
    status?: DatapointStatus | null;
    /**
     * Fx Rate Used
     */
    fx_rate_used?: number | null;
    /**
     * Fx Rate Date
     */
    fx_rate_date?: string | null;
    /**
     * Question Id
     */
    question_id: number;
    /**
     * Numerator Unit Id
     */
    numerator_unit_id: number;
    /**
     * Numerator Reported Unit Id
     */
    numerator_reported_unit_id?: number | null;
    /**
     * Denominator Unit Id
     */
    denominator_unit_id?: number | null;
    /**
     * Denominator Reported Unit Id
     */
    denominator_reported_unit_id?: number | null;
    technology?: TechnologyBase | null;
    /**
     * Impact Question Id
     */
    impact_question_id?: number | null;
    /**
     * Is Primary Cost
     */
    is_primary_cost?: boolean;
};

/**
 * CreateReference
 */
export type CreateReference = {
    /**
     * Source Id
     */
    source_id: number;
    source?: Source | null;
    /**
     * Page Num
     */
    page_num?: number | null;
    /**
     * Highlight Areas
     */
    highlight_areas?: Array<HighlightArea> | null;
};

/**
 * CreateTaxon
 */
export type CreateTaxon = {
    /**
     * Reporting Standards
     */
    reporting_standards?: Array<ReportingStandard> | null;
    /**
     * Primary Reporting Standard Id
     */
    primary_reporting_standard_id?: number | null;
    /**
     * Type
     */
    type: string;
    /**
     * Name
     */
    name: string;
    /**
     * Parent Id
     */
    parent_id?: number | null;
    /**
     * Problem
     */
    problem?: string | null;
    sdg_alignment_type?: SdgAlignmentType | null;
    /**
     * Exclude From Revenue Segments
     */
    exclude_from_revenue_segments?: boolean | null;
    /**
     * Description
     */
    description?: string | null;
};

/**
 * Datapoint
 */
export type Datapoint = {
    /**
     * Datapoint Id
     */
    datapoint_id?: string | null;
    type?: DatapointTypes;
    /**
     * Original Workbook Id
     */
    original_workbook_id?: number | null;
    /**
     * Reported Value
     */
    reported_value?: number | null;
    /**
     * Value
     */
    value: number;
    /**
     * Unit Id
     */
    unit_id: number;
    /**
     * Reported Unit Id
     */
    reported_unit_id?: number | null;
    /**
     * Formula
     */
    formula?: string | null;
    /**
     * Raw
     */
    raw?: boolean;
    /**
     * Reference
     */
    reference?: Reference | CreateReference | null;
    /**
     * Reporting End Date
     */
    reporting_end_date?: string | null;
    /**
     * Assigned Year
     */
    assigned_year?: number | null;
    status?: DatapointStatus | null;
    /**
     * Fx Rate Used
     */
    fx_rate_used?: number | null;
    /**
     * Fx Rate Date
     */
    fx_rate_date?: string | null;
    /**
     * Question Id
     */
    question_id: number;
};

/**
 * DatapointStatus
 */
export const DatapointStatus = { ACCEPTED: 'accepted', CREATED: 'created' } as const;

/**
 * DatapointStatus
 */
export type DatapointStatus = typeof DatapointStatus[keyof typeof DatapointStatus];

/**
 * DatapointTypes
 */
export const DatapointTypes = {
    DATAPOINT: 'datapoint',
    IMPACT: 'impact',
    MACRO_FACTOR: 'macro_factor',
    OUTCOME_LEVEL_1: 'outcome_level_1',
    OUTCOME_LEVEL_2: 'outcome_level_2',
    OUTPUT: 'output',
    REVENUE: 'revenue',
    TECHNOLOGY_COST: 'technology_cost'
} as const;

/**
 * DatapointTypes
 */
export type DatapointTypes = typeof DatapointTypes[keyof typeof DatapointTypes];

/**
 * DatapointWithCell
 */
export type DatapointWithCell = {
    /**
     * Cell
     */
    cell?: string | null;
    /**
     * Answer
     */
    answer?: boolean | null;
    /**
     * Datapoint Id
     */
    datapoint_id?: string | null;
    type?: DatapointTypes;
    /**
     * Original Workbook Id
     */
    original_workbook_id?: number | null;
    /**
     * Reported Value
     */
    reported_value?: number | null;
    /**
     * Value
     */
    value: number;
    /**
     * Unit Id
     */
    unit_id: number;
    /**
     * Reported Unit Id
     */
    reported_unit_id?: number | null;
    /**
     * Formula
     */
    formula?: string | null;
    /**
     * Raw
     */
    raw?: boolean;
    /**
     * Reference
     */
    reference?: Reference | CreateReference | null;
    /**
     * Reporting End Date
     */
    reporting_end_date?: string | null;
    /**
     * Assigned Year
     */
    assigned_year?: number | null;
    status?: DatapointStatus | null;
    /**
     * Fx Rate Used
     */
    fx_rate_used?: number | null;
    /**
     * Fx Rate Date
     */
    fx_rate_date?: string | null;
    /**
     * Question Id
     */
    question_id: number;
};

/**
 * DetailEstimation
 *
 * When pulling the detailed information on an estimation we provide information
 * for all branches
 */
export type DetailEstimation = {
    /**
     * Revenue
     */
    revenue?: Revenue | MacroFactor | TechnologyCost | null;
    /**
     * Output
     */
    output?: Output | MacroFactor | TechnologyCost | null;
    /**
     * Outcome Level 1
     */
    outcome_level_1?: OutcomeLevel1 | MacroFactor | TechnologyCost | null;
    /**
     * Impact
     */
    impact?: Impact | MacroFactor | TechnologyCost | null;
    /**
     * Workbook Id
     */
    workbook_id?: number | null;
    /**
     * Workbook Name
     */
    workbook_name: string;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Technology Id
     */
    technology_id: string;
    /**
     * Technology Name
     */
    technology_name?: string | null;
    /**
     * Reporting End Date
     */
    reporting_end_date: string;
    /**
     * Status
     */
    status?: string | null;
    /**
     * Activity Costs
     */
    activity_costs?: Array<BranchedDatapoint | BranchedMacroFactor | BranchedTechnologyCost | null> | null;
    /**
     * Baseline Costs
     */
    baseline_costs?: Array<BranchedDatapoint | BranchedMacroFactor | BranchedTechnologyCost | null> | null;
    /**
     * Outcome Level 2S
     */
    outcome_level_2s?: Array<BranchedDatapoint | BranchedMacroFactor | BranchedTechnologyCost | null> | null;
};

/**
 * DetailedTechnologyListResponse
 */
export type DetailedTechnologyListResponse = {
    /**
     * Baseline
     *
     * Deprecated in favour of `is_baseline`
     *
     * @deprecated
     */
    baseline?: boolean;
    /**
     * Theme
     */
    theme: string;
    /**
     * Sub Theme
     */
    sub_theme?: string | null;
    /**
     * Domain
     */
    domain?: string | null;
    /**
     * Primary Cost Str
     */
    primary_cost_str?: string | null;
    primary_cost?: TechnologyCost | null;
    /**
     * Reporting Standards
     */
    reporting_standards?: Array<ReportingStandard> | null;
    /**
     * Primary Reporting Standard Id
     */
    primary_reporting_standard_id?: number | null;
    /**
     * Activity Id
     */
    activity_id: string;
    /**
     * Activity Name
     */
    activity_name: string;
    /**
     * Technology Id
     */
    technology_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Technology Name
     *
     * The name of the technology. Deprecated in favour of `name`.
     *
     * @deprecated
     */
    technology_name?: string | null;
    /**
     * Parent Id
     *
     * This should not be `None` moving forward. Set to `None` for the transition period only.
     */
    parent_id?: number | null;
    /**
     * Taxon Id
     *
     * The parent domain taxon ID. Deprecated in favour of `parent_id`.
     *
     * @deprecated
     */
    taxon_id?: number | null;
    /**
     * Type
     */
    type: string;
    /**
     * Is Baseline
     */
    is_baseline?: boolean;
};

/**
 * DomainTaxon
 */
export type DomainTaxon = {
    /**
     * Reporting Standards
     */
    reporting_standards?: Array<ReportingStandard> | null;
    /**
     * Primary Reporting Standard Id
     */
    primary_reporting_standard_id?: number | null;
    /**
     * Is Baseline
     */
    is_baseline: boolean;
    /**
     * Solution
     */
    solution?: string | null;
    /**
     * Impact
     */
    impact?: string | null;
    /**
     * Name
     */
    name: string;
    /**
     * Type
     */
    type: string;
    /**
     * Theme
     */
    theme: string;
    /**
     * Sub Theme
     */
    sub_theme?: string | null;
    /**
     * Domain
     */
    domain?: string | null;
    /**
     * Parent Id
     */
    parent_id?: number | null;
    /**
     * Taxon Id
     */
    taxon_id: number;
    /**
     * Is Complete
     */
    is_complete?: boolean | null;
    sdg_alignment_type: SdgAlignmentType;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Keywords
     */
    keywords?: Array<string> | null;
    /**
     * Exclude From Revenue Segments
     */
    exclude_from_revenue_segments: boolean;
};

/**
 * DomainTaxonResponse
 */
export type DomainTaxonResponse = {
    /**
     * Activities
     */
    activities?: Array<ActivityBase> | null;
    /**
     * Reporting Standards
     */
    reporting_standards?: Array<ReportingStandard> | null;
    /**
     * Primary Reporting Standard Id
     */
    primary_reporting_standard_id?: number | null;
    /**
     * Is Baseline
     */
    is_baseline: boolean;
    /**
     * Solution
     */
    solution?: string | null;
    /**
     * Impact
     */
    impact?: string | null;
    /**
     * Name
     */
    name: string;
    /**
     * Type
     */
    type: string;
    /**
     * Theme
     */
    theme: string;
    /**
     * Sub Theme
     */
    sub_theme?: string | null;
    /**
     * Domain
     */
    domain?: string | null;
    /**
     * Parent Id
     */
    parent_id?: number | null;
    /**
     * Taxon Id
     */
    taxon_id: number;
    /**
     * Is Complete
     */
    is_complete?: boolean | null;
    sdg_alignment_type: SdgAlignmentType;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Keywords
     */
    keywords?: Array<string> | null;
    /**
     * Exclude From Revenue Segments
     */
    exclude_from_revenue_segments: boolean;
};

/**
 * DomainUpdate
 */
export type DomainUpdate = {
    /**
     * Reporting Standards
     */
    reporting_standards?: Array<ReportingStandard> | null;
    /**
     * Primary Reporting Standard Id
     */
    primary_reporting_standard_id?: number | null;
    /**
     * Is Baseline
     */
    is_baseline: boolean;
    /**
     * Solution
     */
    solution?: string | null;
    /**
     * Impact
     */
    impact?: string | null;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Type
     */
    type?: 'domain';
    sdg_alignment_type?: SdgAlignmentType | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Keywords
     */
    keywords?: Array<string> | null;
    /**
     * Exclude From Revenue Segments
     */
    exclude_from_revenue_segments?: boolean | null;
    /**
     * Parent Id
     */
    parent_id?: number | null;
};

/**
 * DomainWithRelationships
 */
export type DomainWithRelationships = {
    /**
     * Is Baseline
     */
    is_baseline: boolean;
    /**
     * Solution
     */
    solution?: string | null;
    /**
     * Impact
     */
    impact?: string | null;
    /**
     * Name
     */
    name: string;
    /**
     * Type
     */
    type: string;
    /**
     * Parent Id
     */
    parent_id?: number | null;
    /**
     * Taxon Id
     */
    taxon_id: number;
    /**
     * Is Complete
     */
    is_complete?: boolean | null;
    sdg_alignment_type: SdgAlignmentType;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Keywords
     */
    keywords?: Array<string> | null;
    /**
     * Exclude From Revenue Segments
     */
    exclude_from_revenue_segments: boolean;
    parent?: Taxon | null;
    /**
     * Children
     */
    children?: Array<Taxon> | null;
};

/**
 * EntityActivities
 */
export type EntityActivities = {
    /**
     * Activities
     */
    activities?: Array<ActivityBase> | null;
    /**
     * Name
     */
    name: string;
    /**
     * Primary Isin
     */
    primary_isin?: string | null;
    /**
     * Headquarters
     */
    headquarters?: string | null;
    /**
     * Sector
     */
    sector?: string | null;
    /**
     * Industry
     */
    industry?: string | null;
    /**
     * Themes
     */
    themes?: Array<string> | null;
    type?: EntityType;
    /**
     * Parent Id
     */
    parent_id?: number | null;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Data Origin Urls
     */
    data_origin_urls?: Array<string> | null;
    /**
     * Is Covered
     */
    is_covered: boolean;
    /**
     * Active Since
     */
    active_since?: string | null;
    /**
     * Inactive Since
     */
    inactive_since?: string | null;
    /**
     * Reporting Month
     */
    reporting_month?: number | null;
    /**
     * Reporting Day
     */
    reporting_day?: number | null;
    /**
     * Isin
     *
     * @deprecated
     */
    isin?: Array<string> | null;
    /**
     * Aligned Sdgs
     */
    aligned_sdgs?: Array<ReportingStandardMajorDetailsWithOrigin> | null;
    /**
     * Has Research
     */
    has_research?: boolean | null;
    /**
     * Is Sdi Covered
     */
    is_sdi_covered?: boolean | null;
    /**
     * Is Sdi Universe
     */
    is_sdi_universe?: boolean | null;
    sdi_classification_type?: EntitySdiClassificationType | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Additional Identifiers
     */
    additional_identifiers?: Array<EntityIdentifierEntry> | null;
};

/**
 * EntityActivitiesOptions
 *
 * Options by which entity activities can be filtered.
 */
export type EntityActivitiesOptions = {
    /**
     * Headquarters
     */
    headquarters: Array<string | null>;
    /**
     * Industry
     */
    industry: Array<string | null>;
    /**
     * Sector
     */
    sector: Array<string | null>;
    /**
     * Has Research
     */
    has_research: Array<boolean | null>;
};

/**
 * EntityIdentifierEntry
 */
export type EntityIdentifierEntry = {
    /**
     * Identifier Type
     */
    identifier_type: string;
    /**
     * Value
     */
    value: string;
};

/**
 * EntitySdiClassificationType
 */
export const EntitySdiClassificationType = {
    CAR_MANUFACTURERS: 'Car_manufacturers',
    CONTROVERSIAL_WEAPONS: 'Controversial_weapons',
    DEVELOPMENT_BANK: 'Development_bank',
    INDUSTRY_CODE: 'Industry_code',
    MINING: 'Mining',
    NO_SDI_INSIGNIFICANT_REVENUE: 'No_SDI_insignificant_revenue',
    NO_SDI_TOPIC_SCORE: 'No_SDI_topic_score',
    REAL_ESTATE: 'Real_estate',
    RETAIL_BANK: 'Retail_bank',
    REVENUE_SEGMENTATION: 'Revenue_segmentation',
    TELCO_SATELLITE_FORMULA: 'Telco_satellite_formula',
    UTILITIES_FORMULA: 'Utilities_formula',
    UTILITIES_FORMULA_GRID: 'Utilities_formula_grid',
    UTILITIES_MULTI_UTIL: 'Utilities_multi_util'
} as const;

/**
 * EntitySdiClassificationType
 */
export type EntitySdiClassificationType = typeof EntitySdiClassificationType[keyof typeof EntitySdiClassificationType];

/**
 * EntityType
 */
export const EntityType = {
    BOND: 'bond',
    COMPANY: 'company',
    PRIVATE: 'private'
} as const;

/**
 * EntityType
 */
export type EntityType = typeof EntityType[keyof typeof EntityType];

/**
 * Estimation
 *
 * Public face of base estimation. Used to create new estimations
 */
export type Estimation = {
    /**
     * Workbook Id
     */
    workbook_id?: number | null;
    /**
     * Workbook Name
     */
    workbook_name: string;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Technology Id
     */
    technology_id: string;
    /**
     * Technology Name
     */
    technology_name?: string | null;
    /**
     * Reporting End Date
     */
    reporting_end_date: string;
    /**
     * Clone From
     */
    clone_from?: number | null;
};

/**
 * EstimationBase
 */
export type EstimationBase = {
    /**
     * Workbook Id
     */
    workbook_id?: number | null;
    /**
     * Workbook Name
     */
    workbook_name: string;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Technology Id
     */
    technology_id: string;
    /**
     * Technology Name
     */
    technology_name?: string | null;
    /**
     * Reporting End Date
     */
    reporting_end_date: string;
};

/**
 * EstimationEntry
 */
export type EstimationEntry = {
    /**
     * Estimation Id
     */
    estimation_id: number;
    /**
     * Datapoint Id
     */
    datapoint_id: string;
    /**
     * Impact Theme
     */
    impact_theme?: string | null;
    /**
     * Datapoint Type
     */
    datapoint_type: string;
};

/**
 * EstimationEntryID
 */
export type EstimationEntryId = {
    /**
     * Estimation Id
     */
    estimation_id: number;
    /**
     * Datapoint Id
     */
    datapoint_id: string;
    /**
     * Impact Theme
     */
    impact_theme?: string | null;
};

/**
 * EstimationSource
 */
export type EstimationSource = {
    /**
     * Source Entity Id
     */
    source_entity_id: number;
    /**
     * Destination Entity Id
     */
    destination_entity_id: number;
    /**
     * Technology Id
     */
    technology_id: string;
};

/**
 * HTTPValidationError
 */
export type HttpValidationError = {
    /**
     * Detail
     */
    detail?: Array<ValidationError>;
};

/**
 * HighlightArea
 */
export type HighlightArea = {
    /**
     * Height
     */
    height: number;
    /**
     * Left
     */
    left: number;
    /**
     * Page Index
     */
    page_index: number;
    /**
     * Top
     */
    top: number;
    /**
     * Width
     */
    width: number;
};

/**
 * Impact
 */
export type Impact = {
    /**
     * Datapoint Id
     */
    datapoint_id?: string | null;
    /**
     * Type
     */
    type?: 'impact';
    /**
     * Original Workbook Id
     */
    original_workbook_id?: number | null;
    /**
     * Reported Value
     */
    reported_value?: number | null;
    /**
     * Value
     */
    value: number;
    /**
     * Unit Id
     */
    unit_id: number;
    /**
     * Reported Unit Id
     */
    reported_unit_id?: number | null;
    /**
     * Formula
     */
    formula?: string | null;
    /**
     * Raw
     */
    raw?: boolean;
    /**
     * Reference
     */
    reference?: Reference | CreateReference | null;
    /**
     * Reporting End Date
     */
    reporting_end_date?: string | null;
    /**
     * Assigned Year
     */
    assigned_year?: number | null;
    status?: DatapointStatus | null;
    /**
     * Fx Rate Used
     */
    fx_rate_used?: number | null;
    /**
     * Fx Rate Date
     */
    fx_rate_date?: string | null;
    /**
     * Question Id
     */
    question_id: number;
};

/**
 * ImpactThemes
 *
 *
 * Hardcoded impact themes (a.k.a. estimation branches).
 *
 */
export const ImpactThemes = {
    'BIODIVERSITY_FOOTPRINT_AVOIDED,_CLIMATE': 'Biodiversity footprint avoided, climate',
    'BIODIVERSITY_FOOTPRINT_AVOIDED,_LAND': 'Biodiversity footprint avoided, land',
    CO2E_AVOIDED: 'CO2e avoided',
    'INCREASE_IN_ECONOMIC_POSITION,_SOCIETY': 'Increase in economic position, society',
    'INCREASE_IN_ECONOMIC_POSITION,_USER': 'Increase in economic position, user',
    ECONOMIC_SAVINGS: 'Economic savings',
    HOSPITAL_VISITS_AVOIDED: 'Hospital visits avoided',
    JOBS_SUPPORTED: 'Jobs supported',
    LAND_SAVED: 'Land saved',
    LIVES_EXTENDED: 'Lives extended',
    N_OX_AVOIDED: 'NOx avoided',
    PM2_5_AVOIDED: 'PM2.5 avoided',
    SICK_DAYS_AVOIDED: 'Sick days avoided',
    SO2_AVOIDED: 'SO2 avoided',
    WATER_SAVED: 'Water saved'
} as const;

/**
 * ImpactThemes
 *
 *
 * Hardcoded impact themes (a.k.a. estimation branches).
 *
 */
export type ImpactThemes = typeof ImpactThemes[keyof typeof ImpactThemes];

/**
 * InputImpactThemes
 */
export const InputImpactThemes = {
    'BIODIVERSITY_FOOTPRINT_AVOIDED,_CLIMATE': 'Biodiversity footprint avoided, climate',
    'BIODIVERSITY_FOOTPRINT_AVOIDED,_LAND': 'Biodiversity footprint avoided, land',
    CO2E_AVOIDED: 'CO2e avoided',
    'INCREASE_IN_ECONOMIC_POSITION,_SOCIETY': 'Increase in economic position, society',
    'INCREASE_IN_ECONOMIC_POSITION,_USER': 'Increase in economic position, user',
    ECONOMIC_SAVINGS: 'Economic savings',
    HOSPITAL_VISITS_AVOIDED: 'Hospital visits avoided',
    JOBS_SUPPORTED: 'Jobs supported',
    LAND_SAVED: 'Land saved',
    LIVES_EXTENDED: 'Lives extended',
    N_OX_AVOIDED: 'NOx avoided',
    PM2_5_AVOIDED: 'PM2.5 avoided',
    SICK_DAYS_AVOIDED: 'Sick days avoided',
    SO2_AVOIDED: 'SO2 avoided',
    NULL: 'null',
    WATER_SAVED: 'Water saved'
} as const;

/**
 * InputImpactThemes
 */
export type InputImpactThemes = typeof InputImpactThemes[keyof typeof InputImpactThemes];

/**
 * ListEstimation
 *
 * When listing all estimations, we expand branches to return one result
 * per estimation-branch pair
 */
export type ListEstimation = {
    /**
     * Revenue
     */
    revenue?: Revenue | MacroFactor | TechnologyCost | null;
    /**
     * Output
     */
    output?: Output | MacroFactor | TechnologyCost | null;
    /**
     * Outcome Level 1
     */
    outcome_level_1?: OutcomeLevel1 | MacroFactor | TechnologyCost | null;
    /**
     * Impact
     */
    impact?: Impact | MacroFactor | TechnologyCost | null;
    /**
     * Workbook Id
     */
    workbook_id?: number | null;
    /**
     * Workbook Name
     */
    workbook_name: string;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Technology Id
     */
    technology_id: string;
    /**
     * Technology Name
     */
    technology_name?: string | null;
    /**
     * Reporting End Date
     */
    reporting_end_date: string;
    impact_theme?: ImpactThemes | null;
    /**
     * Status
     */
    status?: string | null;
    /**
     * Activity Cost
     */
    activity_cost?: TechnologyCost | MacroFactor | Datapoint | null;
    /**
     * Baseline Cost
     */
    baseline_cost?: TechnologyCost | MacroFactor | Datapoint | null;
    outcome_level_2?: Datapoint | null;
};

/**
 * ListTaxonResponse
 */
export type ListTaxonResponse = {
    /**
     * Type
     */
    type: string;
    /**
     * Name
     */
    name: string;
    /**
     * Parent Id
     */
    parent_id?: number | null;
    /**
     * Taxon Id
     */
    taxon_id: number;
    /**
     * Is Complete
     */
    is_complete?: boolean | null;
    sdg_alignment_type: SdgAlignmentType;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Keywords
     */
    keywords?: Array<string> | null;
    /**
     * Exclude From Revenue Segments
     */
    exclude_from_revenue_segments: boolean;
    /**
     * Path
     */
    path: string;
    /**
     * Is Baseline
     */
    is_baseline?: boolean | null;
};

/**
 * ListTaxonResponseWithReportingStandards
 */
export type ListTaxonResponseWithReportingStandards = {
    /**
     * Reporting Standards
     */
    reporting_standards?: Array<ReportingStandard> | null;
    /**
     * Primary Reporting Standard Id
     */
    primary_reporting_standard_id?: number | null;
    /**
     * Type
     */
    type: string;
    /**
     * Name
     */
    name: string;
    /**
     * Parent Id
     */
    parent_id?: number | null;
    /**
     * Taxon Id
     */
    taxon_id: number;
    /**
     * Is Complete
     */
    is_complete?: boolean | null;
    sdg_alignment_type: SdgAlignmentType;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Keywords
     */
    keywords?: Array<string> | null;
    /**
     * Exclude From Revenue Segments
     */
    exclude_from_revenue_segments: boolean;
    /**
     * Path
     */
    path: string;
    /**
     * Is Baseline
     */
    is_baseline?: boolean | null;
};

/**
 * MacroFactor
 */
export type MacroFactor = {
    /**
     * Datapoint Id
     */
    datapoint_id?: string | null;
    type?: DatapointTypes;
    /**
     * Original Workbook Id
     */
    original_workbook_id?: number | null;
    /**
     * Reported Value
     */
    reported_value?: number | null;
    /**
     * Value
     */
    value: number;
    /**
     * Unit Id
     */
    unit_id: number;
    /**
     * Reported Unit Id
     */
    reported_unit_id?: number | null;
    /**
     * Formula
     */
    formula?: string | null;
    /**
     * Raw
     */
    raw?: boolean;
    /**
     * Reference
     */
    reference?: Reference | CreateReference | null;
    /**
     * Reporting End Date
     */
    reporting_end_date?: string | null;
    /**
     * Assigned Year
     */
    assigned_year?: number | null;
    status?: DatapointStatus | null;
    /**
     * Fx Rate Used
     */
    fx_rate_used?: number | null;
    /**
     * Fx Rate Date
     */
    fx_rate_date?: string | null;
    /**
     * Question Id
     */
    question_id: number;
    /**
     * Taxon Id
     */
    taxon_id?: number | null;
    /**
     * Theme
     */
    theme?: string | null;
    /**
     * Macro Factor Name
     */
    macro_factor_name: string;
};

/**
 * MacroFactorWithCell
 */
export type MacroFactorWithCell = {
    /**
     * Cell
     */
    cell?: string | null;
    /**
     * Answer
     */
    answer?: boolean | null;
    /**
     * Datapoint Id
     */
    datapoint_id?: string | null;
    type?: DatapointTypes;
    /**
     * Original Workbook Id
     */
    original_workbook_id?: number | null;
    /**
     * Reported Value
     */
    reported_value?: number | null;
    /**
     * Value
     */
    value: number;
    /**
     * Unit Id
     */
    unit_id: number;
    /**
     * Reported Unit Id
     */
    reported_unit_id?: number | null;
    /**
     * Formula
     */
    formula?: string | null;
    /**
     * Raw
     */
    raw?: boolean;
    /**
     * Reference
     */
    reference?: Reference | CreateReference | null;
    /**
     * Reporting End Date
     */
    reporting_end_date?: string | null;
    /**
     * Assigned Year
     */
    assigned_year?: number | null;
    status?: DatapointStatus | null;
    /**
     * Fx Rate Used
     */
    fx_rate_used?: number | null;
    /**
     * Fx Rate Date
     */
    fx_rate_date?: string | null;
    /**
     * Question Id
     */
    question_id: number;
    /**
     * Taxon Id
     */
    taxon_id?: number | null;
    /**
     * Theme
     */
    theme?: string | null;
    /**
     * Macro Factor Name
     */
    macro_factor_name: string;
};

/**
 * Message
 */
export type Message = {
    /**
     * Msg
     */
    msg: string;
};

/**
 * OutcomeLevel1
 */
export type OutcomeLevel1 = {
    /**
     * Datapoint Id
     */
    datapoint_id?: string | null;
    /**
     * Type
     */
    type?: 'outcome_level_1';
    /**
     * Original Workbook Id
     */
    original_workbook_id?: number | null;
    /**
     * Reported Value
     */
    reported_value?: number | null;
    /**
     * Value
     */
    value: number;
    /**
     * Unit Id
     */
    unit_id: number;
    /**
     * Reported Unit Id
     */
    reported_unit_id?: number | null;
    /**
     * Formula
     */
    formula?: string | null;
    /**
     * Raw
     */
    raw?: boolean;
    /**
     * Reference
     */
    reference?: Reference | CreateReference | null;
    /**
     * Reporting End Date
     */
    reporting_end_date?: string | null;
    /**
     * Assigned Year
     */
    assigned_year?: number | null;
    status?: DatapointStatus | null;
    /**
     * Fx Rate Used
     */
    fx_rate_used?: number | null;
    /**
     * Fx Rate Date
     */
    fx_rate_date?: string | null;
    /**
     * Question Id
     */
    question_id: number;
};

/**
 * Output
 */
export type Output = {
    /**
     * Datapoint Id
     */
    datapoint_id?: string | null;
    /**
     * Type
     */
    type?: 'output';
    /**
     * Original Workbook Id
     */
    original_workbook_id?: number | null;
    /**
     * Reported Value
     */
    reported_value?: number | null;
    /**
     * Value
     */
    value: number;
    /**
     * Unit Id
     */
    unit_id: number;
    /**
     * Reported Unit Id
     */
    reported_unit_id?: number | null;
    /**
     * Formula
     */
    formula?: string | null;
    /**
     * Raw
     */
    raw?: boolean;
    /**
     * Reference
     */
    reference?: Reference | CreateReference | null;
    /**
     * Reporting End Date
     */
    reporting_end_date?: string | null;
    /**
     * Assigned Year
     */
    assigned_year?: number | null;
    status?: DatapointStatus | null;
    /**
     * Fx Rate Used
     */
    fx_rate_used?: number | null;
    /**
     * Fx Rate Date
     */
    fx_rate_date?: string | null;
    /**
     * Question Id
     */
    question_id: number;
};

/**
 * PSIEdge
 */
export type PsiEdge = {
    /**
     * Parent Id
     */
    parent_id: string | number;
    /**
     * Child Id
     */
    child_id: string | number;
    /**
     * Is Original Workbook
     */
    is_original_workbook?: boolean;
};

/**
 * PSIGraph
 */
export type PsiGraph = {
    /**
     * Id
     */
    id: string | number;
    /**
     * Nodes
     */
    nodes: Array<PsiNode>;
    /**
     * Edges
     */
    edges: Array<PsiEdge>;
};

/**
 * PSINode
 */
export type PsiNode = {
    /**
     * Id
     */
    id: string | number;
    /**
     * Is Estimation
     */
    is_estimation?: boolean | null;
    /**
     * Datapoint Name
     */
    datapoint_name?: string | null;
    datapoint_type?: DatapointTypes | null;
    /**
     * Question Name
     */
    question_name?: string | null;
    /**
     * Technology Name
     */
    technology_name?: string | null;
};

/**
 * PaginatedResponse[ActivityMinimalResponse]
 */
export type PaginatedResponseActivityMinimalResponse = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<ActivityMinimalResponse>;
};

/**
 * PaginatedResponse[ActivitySummary]
 */
export type PaginatedResponseActivitySummary = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<ActivitySummary>;
};

/**
 * PaginatedResponse[DetailedTechnologyListResponse]
 */
export type PaginatedResponseDetailedTechnologyListResponse = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<DetailedTechnologyListResponse>;
};

/**
 * PaginatedResponse[EntityActivities]
 */
export type PaginatedResponseEntityActivities = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<EntityActivities>;
};

/**
 * PaginatedResponse[ListEstimation]
 */
export type PaginatedResponseListEstimation = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<ListEstimation>;
};

/**
 * PaginatedResponse[ListTaxonResponseWithReportingStandards]
 */
export type PaginatedResponseListTaxonResponseWithReportingStandards = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<ListTaxonResponseWithReportingStandards>;
};

/**
 * PaginatedResponse[ListTaxonResponse]
 */
export type PaginatedResponseListTaxonResponse = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<ListTaxonResponse>;
};

/**
 * PaginatedResponse[TechnologyCost]
 */
export type PaginatedResponseTechnologyCost = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<TechnologyCost>;
};

/**
 * PaginatedResponse[Union[MacroFactor, TechnologyCost, Datapoint]]
 */
export type PaginatedResponseUnionMacroFactorTechnologyCostDatapoint = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<MacroFactor | TechnologyCost | Datapoint>;
};

/**
 * Reference
 */
export type Reference = {
    /**
     * Source Id
     */
    source_id: number;
    source?: Source | null;
    /**
     * Page Num
     */
    page_num?: number | null;
    /**
     * Highlight Areas
     */
    highlight_areas?: Array<HighlightArea> | null;
    /**
     * Reference Id
     */
    reference_id: number;
};

/**
 * ReportTypes
 */
export const ReportTypes = {
    ACADEMIC_STUDY: 'Academic Study',
    ANNUAL_REPORT: 'Annual Report',
    BLOG_ARTICLE: 'Blog Article',
    BOND_ALLOCATION_REPORT: 'Bond Allocation Report',
    BOND_FINANCIAL_REPORT: 'Bond Financial Report',
    BOND_FRAMEWORK: 'Bond Framework',
    BOND_IMPACT_REPORT: 'Bond Impact Report',
    CDP_REPORT: 'CDP Report',
    CITIZENSHIP_REPORT: 'Citizenship Report',
    COMPANY_SPONSORED_STUDY: 'Company Sponsored Study',
    COMPANY_WEBSITE: 'Company Website',
    CORPORATE_GOVERNANCE: 'Corporate Governance',
    CR_REPORT: 'CR Report',
    CRSD: 'CRSD',
    CSR_REPORT: 'CSR Report',
    DIVERSITY_REPORT: 'Diversity Report',
    EARNINGS_TRANSCRIPT: 'Earnings Transcript',
    EEO_1_REPORT: 'EEO-1 Report',
    ENVIRONMENT_REPORT: 'Environment Report',
    ESG_REPORT: 'ESG Report',
    ETHICS_COMPLIANCE_DECLARATION: 'Ethics / Compliance Declaration',
    FACTSET: 'factset',
    FACTSHEET: 'Factsheet',
    FINANCIAL_STATEMENT: 'Financial Statement',
    FUND_FACTSHEET: 'Fund Factsheet',
    GENDER_PAY_GAP_REPORT: 'Gender Pay Gap Report',
    GRI_INDEX: 'GRI Index',
    IMPACT_REPORT: 'Impact Report',
    INDUSTRY_REPORT: 'Industry Report',
    INTEGRATED_REPORT: 'Integrated Report',
    INVESTOR_PRESENTATION: 'Investor Presentation',
    INVESTOR_REPORT: 'Investor Report',
    MERCHANT_WEBSITE: 'Merchant Website',
    NEWS_ARTICLE: 'News Article',
    NGO_GOVERNMENT_WEBSITE: 'NGO/Government Website',
    OTHER: 'Other',
    PRESS_RELEASE: 'Press Release',
    PRODUCT_SHEET: 'Product Sheet',
    PRODUCT_SPECIFICATION: 'Product Specification',
    PROSPECTUS: 'Prospectus',
    PROXY_STATEMENT: 'Proxy Statement',
    QUARTERLY_REPORT: 'Quarterly Report',
    REMUNERATION_REPORT: 'Remuneration Report',
    '10_K': '10-K',
    '20_F': '20-F',
    SASB_INDEX: 'SASB Index',
    SCIENTIFIC_JOURNAL: 'Scientific Journal',
    SUSTAINABILITY_REPORT: 'Sustainability Report',
    TCFD: 'TCFD',
    TNFD: 'TNFD',
    UNGC_COMMUNICATION_ON_PROGRESS: 'UNGC Communication on Progress',
    UNGC_LETTER_OF_COMMITMENT: 'UNGC Letter of Commitment',
    VERIFICATION_STATEMENT: 'Verification Statement',
    WEBSITE: 'Website',
    WRITE_UP: 'Write Up'
} as const;

/**
 * ReportTypes
 */
export type ReportTypes = typeof ReportTypes[keyof typeof ReportTypes];

/**
 * ReportingStandard
 */
export type ReportingStandard = {
    standard_class: ReportingStandardClasses;
    /**
     * Major Code
     */
    major_code?: string | null;
    /**
     * Link
     */
    link?: string | null;
    /**
     * Colour
     */
    colour?: string | null;
    /**
     * Full Code
     */
    full_code?: string | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Reporting Standard Id
     */
    reporting_standard_id: number;
};

/**
 * ReportingStandardClasses
 */
export const ReportingStandardClasses = {
    EU_SFDR: 'EU SFDR',
    GRI: 'GRI',
    IRIS: 'IRIS+',
    ISSB: 'ISSB',
    SDG: 'SDG'
} as const;

/**
 * ReportingStandardClasses
 */
export type ReportingStandardClasses = typeof ReportingStandardClasses[keyof typeof ReportingStandardClasses];

/**
 * ReportingStandardMajorDetailsWithOrigin
 */
export type ReportingStandardMajorDetailsWithOrigin = {
    standard_class: ReportingStandardClasses;
    /**
     * Major Code
     */
    major_code?: string | null;
    /**
     * Link
     */
    link?: string | null;
    /**
     * Colour
     */
    colour?: string | null;
    /**
     * Origins
     */
    origins?: Array<SdgOrigin> | null;
};

/**
 * Revenue
 */
export type Revenue = {
    /**
     * Datapoint Id
     */
    datapoint_id?: string | null;
    /**
     * Type
     */
    type?: 'revenue';
    /**
     * Original Workbook Id
     */
    original_workbook_id?: number | null;
    /**
     * Reported Value
     */
    reported_value?: number | null;
    /**
     * Value
     */
    value: number;
    /**
     * Unit Id
     */
    unit_id: number;
    /**
     * Reported Unit Id
     */
    reported_unit_id?: number | null;
    /**
     * Formula
     */
    formula?: string | null;
    /**
     * Raw
     */
    raw?: boolean;
    /**
     * Reference
     */
    reference?: Reference | CreateReference | null;
    /**
     * Reporting End Date
     */
    reporting_end_date?: string | null;
    /**
     * Assigned Year
     */
    assigned_year?: number | null;
    status?: DatapointStatus | null;
    /**
     * Fx Rate Used
     */
    fx_rate_used?: number | null;
    /**
     * Fx Rate Date
     */
    fx_rate_date?: string | null;
    /**
     * Question Id
     */
    question_id: number;
};

/**
 * SDGAlignmentType
 */
export const SdgAlignmentType = {
    NEGATIVE: 'negative',
    NOT_COVERED: 'not_covered',
    POSITIVE: 'positive',
    POTENTIAL: 'potential',
    POTENTIALLY_NEGATIVE: 'potentially_negative',
    POTENTIALLY_POSITIVE: 'potentially_positive'
} as const;

/**
 * SDGAlignmentType
 */
export type SdgAlignmentType = typeof SdgAlignmentType[keyof typeof SdgAlignmentType];

/**
 * SDGOrigin
 */
export const SdgOrigin = { REVENUE: 'revenue', OUTCOMES: 'outcomes' } as const;

/**
 * SDGOrigin
 */
export type SdgOrigin = typeof SdgOrigin[keyof typeof SdgOrigin];

/**
 * SDGOutcomesForActivity
 */
export type SdgOutcomesForActivity = {
    [key: string]: Array<number> | null;
};

/**
 * Source
 */
export type Source = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Start
     */
    start?: string | null;
    /**
     * End
     */
    end?: string | null;
    /**
     * Publishing Date
     */
    publishing_date?: string | null;
    /**
     * Original Url
     */
    original_url?: string | null;
    /**
     * Url
     */
    url: string;
    report_type?: ReportTypes | null;
    file_type: SourceType;
    /**
     * Entity Id
     */
    entity_id?: number | null;
    /**
     * Checksum
     */
    checksum?: string | null;
    status?: SourceStatus;
    /**
     * Language
     */
    language?: string | null;
    /**
     * Source Id
     */
    source_id: number;
};

/**
 * SourceStatus
 */
export const SourceStatus = {
    CANDIDATE: 'CANDIDATE',
    CHECK_ENTITY: 'CHECK ENTITY',
    EXTRACTED: 'EXTRACTED',
    NEW: 'NEW',
    REJECTED: 'REJECTED',
    VERIFIED: 'VERIFIED'
} as const;

/**
 * SourceStatus
 */
export type SourceStatus = typeof SourceStatus[keyof typeof SourceStatus];

/**
 * SourceType
 */
export const SourceType = {
    CDP: 'cdp',
    FACTSET: 'factset',
    OTHER: 'other',
    PDF: 'pdf',
    WEBPAGE: 'webpage',
    WEBSITE: 'website',
    XLSX: 'xlsx'
} as const;

/**
 * SourceType
 */
export type SourceType = typeof SourceType[keyof typeof SourceType];

/**
 * SubThemeTaxon
 */
export type SubThemeTaxon = {
    /**
     * Reporting Standards
     */
    reporting_standards?: Array<ReportingStandard> | null;
    /**
     * Primary Reporting Standard Id
     */
    primary_reporting_standard_id?: number | null;
    /**
     * Problem
     */
    problem?: string | null;
    /**
     * Theme
     */
    theme: string;
    /**
     * Sub Theme
     */
    sub_theme?: string | null;
    /**
     * Domain
     */
    domain?: string | null;
    /**
     * Type
     */
    type: string;
    /**
     * Name
     */
    name: string;
    /**
     * Parent Id
     */
    parent_id?: number | null;
    /**
     * Taxon Id
     */
    taxon_id: number;
    /**
     * Is Complete
     */
    is_complete?: boolean | null;
    sdg_alignment_type: SdgAlignmentType;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Keywords
     */
    keywords?: Array<string> | null;
    /**
     * Exclude From Revenue Segments
     */
    exclude_from_revenue_segments: boolean;
};

/**
 * SubThemeTaxonResponse
 */
export type SubThemeTaxonResponse = {
    /**
     * Activities
     */
    activities?: Array<ActivityBase> | null;
    /**
     * Reporting Standards
     */
    reporting_standards?: Array<ReportingStandard> | null;
    /**
     * Primary Reporting Standard Id
     */
    primary_reporting_standard_id?: number | null;
    /**
     * Problem
     */
    problem?: string | null;
    /**
     * Theme
     */
    theme: string;
    /**
     * Sub Theme
     */
    sub_theme?: string | null;
    /**
     * Domain
     */
    domain?: string | null;
    /**
     * Type
     */
    type: string;
    /**
     * Name
     */
    name: string;
    /**
     * Parent Id
     */
    parent_id?: number | null;
    /**
     * Taxon Id
     */
    taxon_id: number;
    /**
     * Is Complete
     */
    is_complete?: boolean | null;
    sdg_alignment_type: SdgAlignmentType;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Keywords
     */
    keywords?: Array<string> | null;
    /**
     * Exclude From Revenue Segments
     */
    exclude_from_revenue_segments: boolean;
};

/**
 * SubThemeUpdate
 */
export type SubThemeUpdate = {
    sdg_alignment_type?: SdgAlignmentType | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Keywords
     */
    keywords?: Array<string> | null;
    /**
     * Exclude From Revenue Segments
     */
    exclude_from_revenue_segments?: boolean | null;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Problem
     */
    problem?: string | null;
    /**
     * Primary Reporting Standard Id
     */
    primary_reporting_standard_id: number;
    /**
     * Parent Id
     */
    parent_id?: number | null;
    /**
     * Type
     */
    type?: 'sub_theme';
};

/**
 * SubThemeWithRelationships
 */
export type SubThemeWithRelationships = {
    /**
     * Problem
     */
    problem?: string | null;
    /**
     * Primary Reporting Standard Id
     */
    primary_reporting_standard_id?: number | null;
    /**
     * Reporting Standards
     */
    reporting_standards?: Array<ReportingStandard> | null;
    /**
     * Type
     */
    type: string;
    /**
     * Name
     */
    name: string;
    /**
     * Parent Id
     */
    parent_id?: number | null;
    /**
     * Taxon Id
     */
    taxon_id: number;
    /**
     * Is Complete
     */
    is_complete?: boolean | null;
    sdg_alignment_type: SdgAlignmentType;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Keywords
     */
    keywords?: Array<string> | null;
    /**
     * Exclude From Revenue Segments
     */
    exclude_from_revenue_segments: boolean;
    parent?: Taxon | null;
    /**
     * Children
     */
    children?: Array<Taxon> | null;
};

/**
 * Taxon
 */
export type Taxon = {
    /**
     * Type
     */
    type: string;
    /**
     * Name
     */
    name: string;
    /**
     * Parent Id
     */
    parent_id?: number | null;
    /**
     * Taxon Id
     */
    taxon_id: number;
    /**
     * Is Complete
     */
    is_complete?: boolean | null;
    sdg_alignment_type: SdgAlignmentType;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Keywords
     */
    keywords?: Array<string> | null;
    /**
     * Exclude From Revenue Segments
     */
    exclude_from_revenue_segments: boolean;
};

/**
 * TaxonEntityMappingForSegment
 */
export type TaxonEntityMappingForSegment = {
    /**
     * Taxon Id
     */
    taxon_id: number;
    /**
     * Entity Ids
     */
    entity_ids?: Array<number> | null;
};

/**
 * TaxonType
 */
export const TaxonType = {
    TECHNOLOGY: 'technology',
    DOMAIN: 'domain',
    SUB_THEME: 'sub_theme',
    THEME: 'theme'
} as const;

/**
 * TaxonType
 */
export type TaxonType = typeof TaxonType[keyof typeof TaxonType];

/**
 * TaxonWithRelationships
 */
export type TaxonWithRelationships = {
    /**
     * Type
     */
    type: string;
    /**
     * Name
     */
    name: string;
    /**
     * Parent Id
     */
    parent_id?: number | null;
    /**
     * Taxon Id
     */
    taxon_id: number;
    /**
     * Is Complete
     */
    is_complete?: boolean | null;
    sdg_alignment_type: SdgAlignmentType;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Keywords
     */
    keywords?: Array<string> | null;
    /**
     * Exclude From Revenue Segments
     */
    exclude_from_revenue_segments: boolean;
    parent?: Taxon | null;
    /**
     * Children
     */
    children?: Array<Taxon> | null;
};

/**
 * TechnologyBase
 */
export type TechnologyBase = {
    /**
     * Technology Id
     */
    technology_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Technology Name
     *
     * The name of the technology. Deprecated in favour of `name`.
     *
     * @deprecated
     */
    technology_name?: string | null;
    /**
     * Parent Id
     *
     * This should not be `None` moving forward. Set to `None` for the transition period only.
     */
    parent_id?: number | null;
    /**
     * Taxon Id
     *
     * The parent domain taxon ID. Deprecated in favour of `parent_id`.
     *
     * @deprecated
     */
    taxon_id?: number | null;
};

/**
 * TechnologyCost
 */
export type TechnologyCost = {
    /**
     * Datapoint Id
     */
    datapoint_id?: string | null;
    type?: DatapointTypes;
    /**
     * Original Workbook Id
     */
    original_workbook_id?: number | null;
    /**
     * Reported Value
     */
    reported_value?: number | null;
    /**
     * Value
     */
    value: number;
    /**
     * Unit Id
     */
    unit_id: number;
    /**
     * Reported Unit Id
     */
    reported_unit_id?: number | null;
    /**
     * Formula
     */
    formula?: string | null;
    /**
     * Raw
     */
    raw?: boolean;
    /**
     * Reference
     */
    reference?: Reference | CreateReference | null;
    /**
     * Reporting End Date
     */
    reporting_end_date?: string | null;
    /**
     * Assigned Year
     */
    assigned_year?: number | null;
    status?: DatapointStatus | null;
    /**
     * Fx Rate Used
     */
    fx_rate_used?: number | null;
    /**
     * Fx Rate Date
     */
    fx_rate_date?: string | null;
    /**
     * Question Id
     */
    question_id: number;
    /**
     * Numerator Unit Id
     */
    numerator_unit_id: number;
    /**
     * Numerator Reported Unit Id
     */
    numerator_reported_unit_id?: number | null;
    /**
     * Denominator Unit Id
     */
    denominator_unit_id?: number | null;
    /**
     * Denominator Reported Unit Id
     */
    denominator_reported_unit_id?: number | null;
    technology?: TechnologyBase | null;
    /**
     * Impact Question Id
     */
    impact_question_id?: number | null;
    /**
     * Is Primary Cost
     */
    is_primary_cost?: boolean;
};

/**
 * TechnologyCostWithCell
 */
export type TechnologyCostWithCell = {
    /**
     * Cell
     */
    cell?: string | null;
    /**
     * Answer
     */
    answer?: boolean | null;
    /**
     * Datapoint Id
     */
    datapoint_id?: string | null;
    type?: DatapointTypes;
    /**
     * Original Workbook Id
     */
    original_workbook_id?: number | null;
    /**
     * Reported Value
     */
    reported_value?: number | null;
    /**
     * Value
     */
    value: number;
    /**
     * Unit Id
     */
    unit_id: number;
    /**
     * Reported Unit Id
     */
    reported_unit_id?: number | null;
    /**
     * Formula
     */
    formula?: string | null;
    /**
     * Raw
     */
    raw?: boolean;
    /**
     * Reference
     */
    reference?: Reference | CreateReference | null;
    /**
     * Reporting End Date
     */
    reporting_end_date?: string | null;
    /**
     * Assigned Year
     */
    assigned_year?: number | null;
    status?: DatapointStatus | null;
    /**
     * Fx Rate Used
     */
    fx_rate_used?: number | null;
    /**
     * Fx Rate Date
     */
    fx_rate_date?: string | null;
    /**
     * Question Id
     */
    question_id: number;
    /**
     * Numerator Unit Id
     */
    numerator_unit_id: number;
    /**
     * Numerator Reported Unit Id
     */
    numerator_reported_unit_id?: number | null;
    /**
     * Denominator Unit Id
     */
    denominator_unit_id?: number | null;
    /**
     * Denominator Reported Unit Id
     */
    denominator_reported_unit_id?: number | null;
    technology?: TechnologyBase | null;
    /**
     * Impact Question Id
     */
    impact_question_id?: number | null;
    /**
     * Is Primary Cost
     */
    is_primary_cost?: boolean;
};

/**
 * TechnologyCreate
 */
export type TechnologyCreate = {
    /**
     * Technology Id
     */
    technology_id?: string | null;
    /**
     * Name
     */
    name: string;
    /**
     * Technology Name
     *
     * The name of the technology. Deprecated in favour of `name`.
     *
     * @deprecated
     */
    technology_name?: string | null;
    /**
     * Parent Id
     *
     * This should not be `None` moving forward. Set to `None` for the transition period only.
     */
    parent_id?: number | null;
    /**
     * Taxon Id
     *
     * The parent domain taxon ID. Deprecated in favour of `parent_id`.
     *
     * @deprecated
     */
    taxon_id?: number | null;
    sdg_alignment_type?: SdgAlignmentType | null;
    /**
     * Exclude From Revenue Segments
     */
    exclude_from_revenue_segments?: boolean | null;
    /**
     * Description
     */
    description?: string | null;
};

/**
 * TechnologyResponse
 */
export type TechnologyResponse = {
    /**
     * Baseline
     *
     * Deprecated in favour of `is_baseline`
     *
     * @deprecated
     */
    baseline?: boolean;
    /**
     * Theme
     */
    theme: string;
    /**
     * Sub Theme
     */
    sub_theme?: string | null;
    /**
     * Domain
     */
    domain?: string | null;
    /**
     * Problem
     *
     * `problem` is now a field on sub theme rather than technology
     *
     * @deprecated
     */
    problem?: string | null;
    /**
     * Solution
     *
     * `solution` is now a field on domain rather than technology
     *
     * @deprecated
     */
    solution?: string | null;
    /**
     * Impact
     *
     * `impact` is now a field on domain rather than technology
     *
     * @deprecated
     */
    impact?: string | null;
    /**
     * Primary Cost Str
     */
    primary_cost_str?: string | null;
    primary_cost?: TechnologyCost | null;
    /**
     * Reporting Standards
     */
    reporting_standards?: Array<ReportingStandard> | null;
    /**
     * Primary Reporting Standard Id
     */
    primary_reporting_standard_id?: number | null;
    /**
     * Activity Id
     */
    activity_id: string;
    /**
     * Activity Name
     */
    activity_name: string;
    /**
     * Technology Id
     */
    technology_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Technology Name
     *
     * The name of the technology. Deprecated in favour of `name`.
     *
     * @deprecated
     */
    technology_name?: string | null;
    /**
     * Parent Id
     *
     * This should not be `None` moving forward. Set to `None` for the transition period only.
     */
    parent_id?: number | null;
    /**
     * Taxon Id
     *
     * The parent domain taxon ID. Deprecated in favour of `parent_id`.
     *
     * @deprecated
     */
    taxon_id?: number | null;
    /**
     * Type
     */
    type: string;
    sdg_alignment_type: SdgAlignmentType;
    /**
     * Exclude From Revenue Segments
     */
    exclude_from_revenue_segments: boolean;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Keywords
     */
    keywords?: Array<string> | null;
    /**
     * Is Baseline
     */
    is_baseline?: boolean;
};

/**
 * TechnologyUpdate
 */
export type TechnologyUpdate = {
    /**
     * Problem
     *
     * `problem` is now a field on sub theme rather than technology
     *
     * @deprecated
     */
    problem?: string | null;
    /**
     * Solution
     *
     * `solution` is now a field on domain rather than technology
     *
     * @deprecated
     */
    solution?: string | null;
    /**
     * Impact
     *
     * `impact` is now a field on domain rather than technology
     *
     * @deprecated
     */
    impact?: string | null;
    /**
     * Reporting Standards
     */
    reporting_standards?: Array<ReportingStandard> | null;
    /**
     * Primary Reporting Standard Id
     */
    primary_reporting_standard_id?: number | null;
    /**
     * Technology Id
     */
    technology_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Technology Name
     *
     * The name of the technology. Deprecated in favour of `name`.
     *
     * @deprecated
     */
    technology_name?: string | null;
    /**
     * Parent Id
     *
     * This should not be `None` moving forward. Set to `None` for the transition period only.
     */
    parent_id?: number | null;
    /**
     * Taxon Id
     *
     * The parent domain taxon ID. Deprecated in favour of `parent_id`.
     *
     * @deprecated
     */
    taxon_id?: number | null;
    /**
     * Primary Cost Id
     */
    primary_cost_id?: string | null;
    /**
     * Accepted Cost Ids
     */
    accepted_cost_ids?: Array<string> | null;
    sdg_alignment_type?: SdgAlignmentType | null;
    /**
     * Exclude From Revenue Segments
     */
    exclude_from_revenue_segments?: boolean | null;
    /**
     * Description
     */
    description?: string | null;
};

/**
 * ThemeTaxon
 */
export type ThemeTaxon = {
    /**
     * Reporting Standards
     */
    reporting_standards?: Array<ReportingStandard> | null;
    /**
     * Primary Reporting Standard Id
     */
    primary_reporting_standard_id?: number | null;
    /**
     * Theme
     */
    theme: string;
    /**
     * Sub Theme
     */
    sub_theme?: string | null;
    /**
     * Domain
     */
    domain?: string | null;
    /**
     * Type
     */
    type: string;
    /**
     * Name
     */
    name: string;
    /**
     * Parent Id
     */
    parent_id?: number | null;
    /**
     * Taxon Id
     */
    taxon_id: number;
    /**
     * Is Complete
     */
    is_complete?: boolean | null;
    sdg_alignment_type: SdgAlignmentType;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Keywords
     */
    keywords?: Array<string> | null;
    /**
     * Exclude From Revenue Segments
     */
    exclude_from_revenue_segments: boolean;
};

/**
 * ThemeTaxonResponse
 */
export type ThemeTaxonResponse = {
    /**
     * Activities
     */
    activities?: Array<ActivityBase> | null;
    /**
     * Reporting Standards
     */
    reporting_standards?: Array<ReportingStandard> | null;
    /**
     * Primary Reporting Standard Id
     */
    primary_reporting_standard_id?: number | null;
    /**
     * Theme
     */
    theme: string;
    /**
     * Sub Theme
     */
    sub_theme?: string | null;
    /**
     * Domain
     */
    domain?: string | null;
    /**
     * Type
     */
    type: string;
    /**
     * Name
     */
    name: string;
    /**
     * Parent Id
     */
    parent_id?: number | null;
    /**
     * Taxon Id
     */
    taxon_id: number;
    /**
     * Is Complete
     */
    is_complete?: boolean | null;
    sdg_alignment_type: SdgAlignmentType;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Keywords
     */
    keywords?: Array<string> | null;
    /**
     * Exclude From Revenue Segments
     */
    exclude_from_revenue_segments: boolean;
};

/**
 * ThemeUpdate
 */
export type ThemeUpdate = {
    /**
     * Reporting Standards
     */
    reporting_standards?: Array<ReportingStandard> | null;
    /**
     * Primary Reporting Standard Id
     */
    primary_reporting_standard_id?: number | null;
    sdg_alignment_type?: SdgAlignmentType | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Keywords
     */
    keywords?: Array<string> | null;
    /**
     * Exclude From Revenue Segments
     */
    exclude_from_revenue_segments?: boolean | null;
    /**
     * Type
     */
    type?: 'theme';
};

/**
 * TheoryOfChangeForActivity
 */
export type TheoryOfChangeForActivity = {
    /**
     * Revenue
     */
    revenue?: Array<BaseQuestionDetails> | null;
    /**
     * Output
     */
    output?: Array<BaseQuestionDetails> | null;
    /**
     * Outcome Level 1
     */
    outcome_level_1?: Array<BaseQuestionDetails> | null;
    /**
     * Outcome Level 2
     */
    outcome_level_2?: Array<BaseQuestionDetails> | null;
};

/**
 * ValidationError
 */
export type ValidationError = {
    /**
     * Location
     */
    loc: Array<string | number>;
    /**
     * Message
     */
    msg: string;
    /**
     * Error Type
     */
    type: string;
    /**
     * Input
     */
    input?: unknown;
    /**
     * Context
     */
    ctx?: {
        [key: string]: unknown;
    };
};

/**
 * Workbook
 */
export type Workbook = {
    /**
     * Workbook Id
     */
    workbook_id?: number | null;
    /**
     * Workbook Name
     */
    workbook_name: string;
    /**
     * Datapoints
     */
    datapoints?: Array<MacroFactorWithCell | TechnologyCostWithCell | DatapointWithCell> | null;
    /**
     * Defines
     */
    defines?: Array<MacroFactor | TechnologyCost | Datapoint> | null;
};

/**
 * WorkbookEntry
 */
export type WorkbookEntry = {
    /**
     * Cell
     */
    cell?: string | null;
    /**
     * Answer
     */
    answer?: boolean | null;
    /**
     * Workbook Id
     */
    workbook_id: number;
    /**
     * Datapoint Id
     */
    datapoint_id?: string | null;
};

/**
 * WorkbookEntryID
 */
export type WorkbookEntryId = {
    /**
     * Workbook Id
     */
    workbook_id: number;
    /**
     * Datapoint Id
     */
    datapoint_id?: string | null;
};

/**
 * WorkbookWithDatapoints
 */
export type WorkbookWithDatapoints = {
    /**
     * Datapoints
     */
    datapoints?: Array<MacroFactorWithCell | TechnologyCostWithCell | DatapointWithCell> | null;
    /**
     * Workbook Id
     */
    workbook_id?: number | null;
};

export type GetActivitySummariesData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/activities/summary';
};

export type GetActivitySummariesErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetActivitySummariesError = GetActivitySummariesErrors[keyof GetActivitySummariesErrors];

export type GetActivitySummariesResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseActivitySummary;
};

export type GetActivitySummariesResponse = GetActivitySummariesResponses[keyof GetActivitySummariesResponses];

export type ListActivitiesData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/activities';
};

export type ListActivitiesErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListActivitiesError = ListActivitiesErrors[keyof ListActivitiesErrors];

export type ListActivitiesResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseDetailedTechnologyListResponse;
};

export type ListActivitiesResponse = ListActivitiesResponses[keyof ListActivitiesResponses];

export type CreateActivityData = {
    body: TechnologyCreate;
    path?: never;
    query?: never;
    url: '/api/v1/activities';
};

export type CreateActivityErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type CreateActivityError = CreateActivityErrors[keyof CreateActivityErrors];

export type CreateActivityResponses = {
    /**
     * Successful Response
     */
    201: TechnologyResponse;
};

export type CreateActivityResponse = CreateActivityResponses[keyof CreateActivityResponses];

export type ListLatestActivitiesData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/activities/latest';
};

export type ListLatestActivitiesErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListLatestActivitiesError = ListLatestActivitiesErrors[keyof ListLatestActivitiesErrors];

export type ListLatestActivitiesResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseDetailedTechnologyListResponse;
};

export type ListLatestActivitiesResponse = ListLatestActivitiesResponses[keyof ListLatestActivitiesResponses];

export type ListActivitiesMinimalData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/activities/minimal';
};

export type ListActivitiesMinimalErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListActivitiesMinimalError = ListActivitiesMinimalErrors[keyof ListActivitiesMinimalErrors];

export type ListActivitiesMinimalResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseActivityMinimalResponse;
};

export type ListActivitiesMinimalResponse = ListActivitiesMinimalResponses[keyof ListActivitiesMinimalResponses];

export type DeleteActivityData = {
    body?: never;
    path: {
        /**
         * Activity Id
         */
        activity_id: string;
    };
    query?: never;
    url: '/api/v1/activities/{activity_id}';
};

export type DeleteActivityErrors = {
    /**
     * Method Not Allowed
     */
    405: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type DeleteActivityError = DeleteActivityErrors[keyof DeleteActivityErrors];

export type DeleteActivityResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GetActivityData = {
    body?: never;
    path: {
        /**
         * Activity Id
         */
        activity_id: string;
    };
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/activities/{activity_id}';
};

export type GetActivityErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetActivityError = GetActivityErrors[keyof GetActivityErrors];

export type GetActivityResponses = {
    /**
     * Successful Response
     */
    200: TechnologyResponse;
};

export type GetActivityResponse = GetActivityResponses[keyof GetActivityResponses];

export type UpdateActivityData = {
    body: TechnologyUpdate;
    path: {
        /**
         * Activity Id
         */
        activity_id: string;
    };
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/activities/{activity_id}';
};

export type UpdateActivityErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UpdateActivityError = UpdateActivityErrors[keyof UpdateActivityErrors];

export type UpdateActivityResponses = {
    /**
     * Successful Response
     */
    200: TechnologyResponse;
};

export type UpdateActivityResponse = UpdateActivityResponses[keyof UpdateActivityResponses];

export type GetLatestActivityData = {
    body?: never;
    path: {
        /**
         * Activity Id
         */
        activity_id: string;
    };
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/activities/{activity_id}/latest';
};

export type GetLatestActivityErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetLatestActivityError = GetLatestActivityErrors[keyof GetLatestActivityErrors];

export type GetLatestActivityResponses = {
    /**
     * Successful Response
     */
    200: TechnologyResponse;
};

export type GetLatestActivityResponse = GetLatestActivityResponses[keyof GetLatestActivityResponses];

export type ListTechnologyCostsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/costs';
};

export type ListTechnologyCostsErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListTechnologyCostsError = ListTechnologyCostsErrors[keyof ListTechnologyCostsErrors];

export type ListTechnologyCostsResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseTechnologyCost;
};

export type ListTechnologyCostsResponse = ListTechnologyCostsResponses[keyof ListTechnologyCostsResponses];

export type ListDatapointsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/datapoints';
};

export type ListDatapointsErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListDatapointsError = ListDatapointsErrors[keyof ListDatapointsErrors];

export type ListDatapointsResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseUnionMacroFactorTechnologyCostDatapoint;
};

export type ListDatapointsResponse = ListDatapointsResponses[keyof ListDatapointsResponses];

export type SearchRelatedDatapointsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Year
         */
        year?: number | null;
        /**
         * Entity Id
         */
        entity_id?: number | null;
        /**
         * Search Term
         */
        search_term?: string | null;
        /**
         * Domain Name
         */
        domain_name?: string | null;
        /**
         * Technology Name
         */
        technology_name?: string | null;
        /**
         * Datapoint Type
         */
        datapoint_type?: Array<string> | null;
        /**
         * Use Current Sub Theme
         */
        use_current_sub_theme?: boolean | null;
    };
    url: '/api/v1/datapoints/search_related';
};

export type SearchRelatedDatapointsErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type SearchRelatedDatapointsError = SearchRelatedDatapointsErrors[keyof SearchRelatedDatapointsErrors];

export type SearchRelatedDatapointsResponses = {
    /**
     * Response Search Related Datapoints
     *
     * Successful Response
     */
    200: Array<MacroFactor | TechnologyCost | Datapoint>;
};

export type SearchRelatedDatapointsResponse = SearchRelatedDatapointsResponses[keyof SearchRelatedDatapointsResponses];

export type DeleteDatapointData = {
    body?: never;
    path: {
        /**
         * Datapoint Id
         */
        datapoint_id: string;
    };
    query?: never;
    url: '/api/v1/datapoints/{datapoint_id}';
};

export type DeleteDatapointErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type DeleteDatapointError = DeleteDatapointErrors[keyof DeleteDatapointErrors];

export type DeleteDatapointResponses = {
    /**
     * Successful Response
     */
    204: void;
};

export type DeleteDatapointResponse = DeleteDatapointResponses[keyof DeleteDatapointResponses];

export type GetDatapointData = {
    body?: never;
    path: {
        /**
         * Datapoint Id
         */
        datapoint_id: string;
    };
    query?: never;
    url: '/api/v1/datapoints/{datapoint_id}';
};

export type GetDatapointErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetDatapointError = GetDatapointErrors[keyof GetDatapointErrors];

export type GetDatapointResponses = {
    /**
     * Response Get Datapoint
     *
     * Successful Response
     */
    200: MacroFactor | TechnologyCost | Datapoint;
};

export type GetDatapointResponse = GetDatapointResponses[keyof GetDatapointResponses];

export type UpdateDatapointData = {
    /**
     * Data
     */
    body: MacroFactor | TechnologyCost | Datapoint;
    path: {
        /**
         * Datapoint Id
         */
        datapoint_id: string;
    };
    query?: never;
    url: '/api/v1/datapoints/{datapoint_id}';
};

export type UpdateDatapointErrors = {
    /**
     * Unprocessable Content
     */
    422: Message;
};

export type UpdateDatapointError = UpdateDatapointErrors[keyof UpdateDatapointErrors];

export type UpdateDatapointResponses = {
    /**
     * Response Update Datapoint
     *
     * Successful Response
     */
    200: MacroFactor | TechnologyCost | Datapoint;
};

export type UpdateDatapointResponse = UpdateDatapointResponses[keyof UpdateDatapointResponses];

export type GetDatapointGraphData = {
    body?: never;
    path: {
        /**
         * Datapoint Id
         */
        datapoint_id: string;
    };
    query?: {
        /**
         * Additional Ids
         */
        additional_ids?: Array<string | number>;
        /**
         * Exclude All Domain Bound Nodes
         */
        exclude_all_domain_bound_nodes?: boolean;
    };
    url: '/api/v1/datapoints/{datapoint_id}/graph';
};

export type GetDatapointGraphErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetDatapointGraphError = GetDatapointGraphErrors[keyof GetDatapointGraphErrors];

export type GetDatapointGraphResponses = {
    /**
     * Successful Response
     */
    200: PsiGraph;
};

export type GetDatapointGraphResponse = GetDatapointGraphResponses[keyof GetDatapointGraphResponses];

export type ListEstimationsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/estimations';
};

export type ListEstimationsErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListEstimationsError = ListEstimationsErrors[keyof ListEstimationsErrors];

export type ListEstimationsResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseListEstimation;
};

export type ListEstimationsResponse = ListEstimationsResponses[keyof ListEstimationsResponses];

export type CreateOrCloneEstimationData = {
    body: Estimation;
    path?: never;
    query?: never;
    url: '/api/v1/estimations';
};

export type CreateOrCloneEstimationErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Unprocessable Content
     */
    422: Message;
};

export type CreateOrCloneEstimationError = CreateOrCloneEstimationErrors[keyof CreateOrCloneEstimationErrors];

export type CreateOrCloneEstimationResponses = {
    /**
     * Successful Response
     */
    201: Estimation;
};

export type CreateOrCloneEstimationResponse = CreateOrCloneEstimationResponses[keyof CreateOrCloneEstimationResponses];

export type GetEstimationsForEntityAndTechnologyData = {
    body?: never;
    path: {
        /**
         * Entity Id
         */
        entity_id: number;
        /**
         * Technology Id
         */
        technology_id: string;
    };
    query?: {
        /**
         * Status
         *
         * Datapoint status to query against. Deprecated.
         *
         * @deprecated
         */
        status?: DatapointStatus | null;
        /**
         * Active Only
         *
         * Only show data for active entities.
         */
        active_only?: boolean;
    };
    url: '/api/v1/estimations/{entity_id}/{technology_id}';
};

export type GetEstimationsForEntityAndTechnologyErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetEstimationsForEntityAndTechnologyError = GetEstimationsForEntityAndTechnologyErrors[keyof GetEstimationsForEntityAndTechnologyErrors];

export type GetEstimationsForEntityAndTechnologyResponses = {
    /**
     * Response Get Estimations For Entity And Technology
     *
     * Successful Response
     */
    200: Array<DetailEstimation>;
};

export type GetEstimationsForEntityAndTechnologyResponse = GetEstimationsForEntityAndTechnologyResponses[keyof GetEstimationsForEntityAndTechnologyResponses];

export type CloneEstimationsData = {
    body: EstimationSource;
    path?: never;
    query?: never;
    url: '/api/v1/estimations/clone';
};

export type CloneEstimationsErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type CloneEstimationsError = CloneEstimationsErrors[keyof CloneEstimationsErrors];

export type CloneEstimationsResponses = {
    /**
     * Response Clone Estimations
     *
     * Successful Response
     */
    201: Array<EstimationBase>;
};

export type CloneEstimationsResponse = CloneEstimationsResponses[keyof CloneEstimationsResponses];

export type AcceptEstimationData = {
    body?: never;
    path: {
        /**
         * Estimation Id
         */
        estimation_id: number;
        impact_theme: InputImpactThemes;
    };
    query?: never;
    url: '/api/v1/estimations/{estimation_id}/{impact_theme}/accept';
};

export type AcceptEstimationErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type AcceptEstimationError = AcceptEstimationErrors[keyof AcceptEstimationErrors];

export type AcceptEstimationResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type RejectEstimationData = {
    body?: never;
    path: {
        /**
         * Estimation Id
         */
        estimation_id: number;
        impact_theme: InputImpactThemes;
    };
    query?: never;
    url: '/api/v1/estimations/{estimation_id}/{impact_theme}/reject';
};

export type RejectEstimationErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type RejectEstimationError = RejectEstimationErrors[keyof RejectEstimationErrors];

export type RejectEstimationResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type DeleteEstimationData = {
    body?: never;
    path: {
        /**
         * Estimation Id
         */
        estimation_id: number;
    };
    query?: never;
    url: '/api/v1/estimations/{estimation_id}';
};

export type DeleteEstimationErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type DeleteEstimationError = DeleteEstimationErrors[keyof DeleteEstimationErrors];

export type DeleteEstimationResponses = {
    /**
     * Successful Response
     */
    204: void;
};

export type DeleteEstimationResponse = DeleteEstimationResponses[keyof DeleteEstimationResponses];

export type DetachDatapointFromEstimationData = {
    body: EstimationEntryId;
    path: {
        /**
         * Estimation Id
         */
        estimation_id: number;
    };
    query?: never;
    url: '/api/v1/estimations/{estimation_id}/datapoints';
};

export type DetachDatapointFromEstimationErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type DetachDatapointFromEstimationError = DetachDatapointFromEstimationErrors[keyof DetachDatapointFromEstimationErrors];

export type DetachDatapointFromEstimationResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type AttachDatapointToEstimationData = {
    body: EstimationEntry;
    path: {
        /**
         * Estimation Id
         */
        estimation_id: number;
    };
    query?: never;
    url: '/api/v1/estimations/{estimation_id}/datapoints';
};

export type AttachDatapointToEstimationErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type AttachDatapointToEstimationError = AttachDatapointToEstimationErrors[keyof AttachDatapointToEstimationErrors];

export type AttachDatapointToEstimationResponses = {
    /**
     * Successful Response
     */
    201: unknown;
};

export type DeleteBranchData = {
    body?: never;
    path: {
        /**
         * Estimation Id
         */
        estimation_id: number;
        impact_theme: ImpactThemes;
    };
    query?: never;
    url: '/api/v1/estimations/{estimation_id}/{impact_theme}';
};

export type DeleteBranchErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type DeleteBranchError = DeleteBranchErrors[keyof DeleteBranchErrors];

export type DeleteBranchResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type UpdateReportingEndDateData = {
    body?: never;
    path: {
        /**
         * Estimation Id
         */
        estimation_id: number;
        /**
         * Reporting End Date
         */
        reporting_end_date: string;
    };
    query?: never;
    url: '/api/v1/estimations/{estimation_id}/reporting-end-date/{reporting_end_date}';
};

export type UpdateReportingEndDateErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Unprocessable Content
     */
    422: Message;
};

export type UpdateReportingEndDateError = UpdateReportingEndDateErrors[keyof UpdateReportingEndDateErrors];

export type UpdateReportingEndDateResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type ListTaxonomiesData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/taxonomy';
};

export type ListTaxonomiesErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListTaxonomiesError = ListTaxonomiesErrors[keyof ListTaxonomiesErrors];

export type ListTaxonomiesResponses = {
    /**
     * Response List Taxonomies
     *
     * Successful Response
     */
    200: PaginatedResponseListTaxonResponseWithReportingStandards | PaginatedResponseListTaxonResponse;
};

export type ListTaxonomiesResponse = ListTaxonomiesResponses[keyof ListTaxonomiesResponses];

export type CreateTaxonData = {
    body: CreateTaxon;
    path?: never;
    query?: never;
    url: '/api/v1/taxonomy';
};

export type CreateTaxonErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Unprocessable Content
     */
    422: Message;
};

export type CreateTaxonError = CreateTaxonErrors[keyof CreateTaxonErrors];

export type CreateTaxonResponses = {
    /**
     * Successful Response
     */
    201: Taxon;
};

export type CreateTaxonResponse = CreateTaxonResponses[keyof CreateTaxonResponses];

export type ListLatestTaxonomiesData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/taxonomy/latest';
};

export type ListLatestTaxonomiesErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListLatestTaxonomiesError = ListLatestTaxonomiesErrors[keyof ListLatestTaxonomiesErrors];

export type ListLatestTaxonomiesResponses = {
    /**
     * Response List Latest Taxonomies
     *
     * Successful Response
     */
    200: PaginatedResponseListTaxonResponseWithReportingStandards | PaginatedResponseListTaxonResponse;
};

export type ListLatestTaxonomiesResponse = ListLatestTaxonomiesResponses[keyof ListLatestTaxonomiesResponses];

export type ListTaxonomiesByTypeData = {
    body?: never;
    path: {
        taxon_type: TaxonType;
    };
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/taxonomy/type/{taxon_type}';
};

export type ListTaxonomiesByTypeErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListTaxonomiesByTypeError = ListTaxonomiesByTypeErrors[keyof ListTaxonomiesByTypeErrors];

export type ListTaxonomiesByTypeResponses = {
    /**
     * Response List Taxonomies By Type
     *
     * Successful Response
     */
    200: Array<DomainWithRelationships | SubThemeWithRelationships | TaxonWithRelationships>;
};

export type ListTaxonomiesByTypeResponse = ListTaxonomiesByTypeResponses[keyof ListTaxonomiesByTypeResponses];

export type ListLatestTaxonomiesByTypeData = {
    body?: never;
    path: {
        taxon_type: TaxonType;
    };
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/taxonomy/type/{taxon_type}/latest';
};

export type ListLatestTaxonomiesByTypeErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListLatestTaxonomiesByTypeError = ListLatestTaxonomiesByTypeErrors[keyof ListLatestTaxonomiesByTypeErrors];

export type ListLatestTaxonomiesByTypeResponses = {
    /**
     * Response List Latest Taxonomies By Type
     *
     * Successful Response
     */
    200: Array<DomainWithRelationships | SubThemeWithRelationships | TaxonWithRelationships>;
};

export type ListLatestTaxonomiesByTypeResponse = ListLatestTaxonomiesByTypeResponses[keyof ListLatestTaxonomiesByTypeResponses];

export type DeleteTaxonData = {
    body?: never;
    path: {
        /**
         * Taxon Id
         */
        taxon_id: number;
    };
    query?: never;
    url: '/api/v1/taxonomy/{taxon_id}';
};

export type DeleteTaxonErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type DeleteTaxonError = DeleteTaxonErrors[keyof DeleteTaxonErrors];

export type DeleteTaxonResponses = {
    /**
     * Successful Response
     */
    204: void;
};

export type DeleteTaxonResponse = DeleteTaxonResponses[keyof DeleteTaxonResponses];

export type GetTaxonData = {
    body?: never;
    path: {
        /**
         * Taxon Id
         */
        taxon_id: number;
    };
    query?: {
        /**
         * Include Activities
         */
        include_activities?: boolean;
    };
    url: '/api/v1/taxonomy/{taxon_id}';
};

export type GetTaxonErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetTaxonError = GetTaxonErrors[keyof GetTaxonErrors];

export type GetTaxonResponses = {
    /**
     * Response Get Taxon
     *
     * Successful Response
     */
    200: ActivityTaxonResponse | DomainTaxonResponse | SubThemeTaxonResponse | ThemeTaxonResponse;
};

export type GetTaxonResponse = GetTaxonResponses[keyof GetTaxonResponses];

export type UpdateTaxonData = {
    /**
     * Taxon Update
     */
    body: DomainUpdate | SubThemeUpdate | ThemeUpdate;
    path: {
        /**
         * Taxon Id
         */
        taxon_id: number;
    };
    query?: never;
    url: '/api/v1/taxonomy/{taxon_id}';
};

export type UpdateTaxonErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UpdateTaxonError = UpdateTaxonErrors[keyof UpdateTaxonErrors];

export type UpdateTaxonResponses = {
    /**
     * Response Update Taxon
     *
     * Successful Response
     */
    200: DomainTaxon | SubThemeTaxon | ThemeTaxon;
};

export type UpdateTaxonResponse = UpdateTaxonResponses[keyof UpdateTaxonResponses];

export type GetLatestTaxonData = {
    body?: never;
    path: {
        /**
         * Taxon Id
         */
        taxon_id: number;
    };
    query?: {
        /**
         * Include Activities
         */
        include_activities?: boolean;
    };
    url: '/api/v1/taxonomy/{taxon_id}/latest';
};

export type GetLatestTaxonErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetLatestTaxonError = GetLatestTaxonErrors[keyof GetLatestTaxonErrors];

export type GetLatestTaxonResponses = {
    /**
     * Response Get Latest Taxon
     *
     * Successful Response
     */
    200: ActivityTaxonResponse | DomainTaxonResponse | SubThemeTaxonResponse | ThemeTaxonResponse;
};

export type GetLatestTaxonResponse = GetLatestTaxonResponses[keyof GetLatestTaxonResponses];

export type GetTaxonEntitiesData = {
    body?: never;
    path: {
        /**
         * Taxon Id
         */
        taxon_id: number;
    };
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/taxonomy/{taxon_id}/entities';
};

export type GetTaxonEntitiesErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetTaxonEntitiesError = GetTaxonEntitiesErrors[keyof GetTaxonEntitiesErrors];

export type GetTaxonEntitiesResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseEntityActivities;
};

export type GetTaxonEntitiesResponse = GetTaxonEntitiesResponses[keyof GetTaxonEntitiesResponses];

export type GetTaxonEntitiesOptionsData = {
    body?: never;
    path: {
        /**
         * Taxon Id
         */
        taxon_id: number;
    };
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/taxonomy/{taxon_id}/entities/options';
};

export type GetTaxonEntitiesOptionsErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetTaxonEntitiesOptionsError = GetTaxonEntitiesOptionsErrors[keyof GetTaxonEntitiesOptionsErrors];

export type GetTaxonEntitiesOptionsResponses = {
    /**
     * Successful Response
     */
    200: EntityActivitiesOptions;
};

export type GetTaxonEntitiesOptionsResponse = GetTaxonEntitiesOptionsResponses[keyof GetTaxonEntitiesOptionsResponses];

export type GetOutcomesPerSdgForActivityData = {
    body?: never;
    path: {
        /**
         * Taxon Id
         */
        taxon_id: number;
    };
    query?: never;
    url: '/api/v1/taxonomy/{taxon_id}/outcomes';
};

export type GetOutcomesPerSdgForActivityErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetOutcomesPerSdgForActivityError = GetOutcomesPerSdgForActivityErrors[keyof GetOutcomesPerSdgForActivityErrors];

export type GetOutcomesPerSdgForActivityResponses = {
    /**
     * Successful Response
     */
    200: SdgOutcomesForActivity;
};

export type GetOutcomesPerSdgForActivityResponse = GetOutcomesPerSdgForActivityResponses[keyof GetOutcomesPerSdgForActivityResponses];

export type GetTheoryOfChangeForActivityData = {
    body?: never;
    path: {
        /**
         * Taxon Id
         */
        taxon_id: number;
    };
    query?: never;
    url: '/api/v1/taxonomy/{taxon_id}/theory_of_change';
};

export type GetTheoryOfChangeForActivityErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetTheoryOfChangeForActivityError = GetTheoryOfChangeForActivityErrors[keyof GetTheoryOfChangeForActivityErrors];

export type GetTheoryOfChangeForActivityResponses = {
    /**
     * Successful Response
     */
    200: TheoryOfChangeForActivity;
};

export type GetTheoryOfChangeForActivityResponse = GetTheoryOfChangeForActivityResponses[keyof GetTheoryOfChangeForActivityResponses];

export type GetTaxonBaselinesData = {
    body?: never;
    path: {
        /**
         * Taxon Id
         */
        taxon_id: number;
    };
    query?: never;
    url: '/api/v1/taxonomy/{taxon_id}/baseline';
};

export type GetTaxonBaselinesErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetTaxonBaselinesError = GetTaxonBaselinesErrors[keyof GetTaxonBaselinesErrors];

export type GetTaxonBaselinesResponses = {
    /**
     * Response Get Taxon Baselines
     *
     * Successful Response
     */
    200: Array<Taxon>;
};

export type GetTaxonBaselinesResponse = GetTaxonBaselinesResponses[keyof GetTaxonBaselinesResponses];

export type GetTaxonSolutionsData = {
    body?: never;
    path: {
        /**
         * Taxon Id
         */
        taxon_id: number;
    };
    query?: never;
    url: '/api/v1/taxonomy/{taxon_id}/solution';
};

export type GetTaxonSolutionsErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetTaxonSolutionsError = GetTaxonSolutionsErrors[keyof GetTaxonSolutionsErrors];

export type GetTaxonSolutionsResponses = {
    /**
     * Response Get Taxon Solutions
     *
     * Successful Response
     */
    200: Array<Taxon>;
};

export type GetTaxonSolutionsResponse = GetTaxonSolutionsResponses[keyof GetTaxonSolutionsResponses];

export type GetSegmentMappingsData = {
    body?: never;
    path: {
        /**
         * Segment Id
         */
        segment_id: number;
    };
    query?: never;
    url: '/api/v1/taxonomy/segment_mappings/{segment_id}';
};

export type GetSegmentMappingsErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetSegmentMappingsError = GetSegmentMappingsErrors[keyof GetSegmentMappingsErrors];

export type GetSegmentMappingsResponses = {
    /**
     * Response Get Segment Mappings
     *
     * Successful Response
     */
    200: Array<TaxonEntityMappingForSegment>;
};

export type GetSegmentMappingsResponse = GetSegmentMappingsResponses[keyof GetSegmentMappingsResponses];

export type GetLatestSegmentMappingsData = {
    body?: never;
    path: {
        /**
         * Segment Id
         */
        segment_id: number;
    };
    query?: never;
    url: '/api/v1/taxonomy/segment_mappings/{segment_id}/latest';
};

export type GetLatestSegmentMappingsErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetLatestSegmentMappingsError = GetLatestSegmentMappingsErrors[keyof GetLatestSegmentMappingsErrors];

export type GetLatestSegmentMappingsResponses = {
    /**
     * Response Get Latest Segment Mappings
     *
     * Successful Response
     */
    200: Array<TaxonEntityMappingForSegment>;
};

export type GetLatestSegmentMappingsResponse = GetLatestSegmentMappingsResponses[keyof GetLatestSegmentMappingsResponses];

export type DeleteWorkbookEntryData = {
    body: WorkbookEntryId;
    path: {
        /**
         * Workbook Id
         */
        workbook_id: number;
    };
    query?: never;
    url: '/api/v1/workbooks/{workbook_id}';
};

export type DeleteWorkbookEntryErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type DeleteWorkbookEntryError = DeleteWorkbookEntryErrors[keyof DeleteWorkbookEntryErrors];

export type DeleteWorkbookEntryResponses = {
    /**
     * Successful Response
     */
    204: void;
};

export type DeleteWorkbookEntryResponse = DeleteWorkbookEntryResponses[keyof DeleteWorkbookEntryResponses];

export type GetWorkbookData = {
    body?: never;
    path: {
        /**
         * Workbook Id
         */
        workbook_id: number;
    };
    query?: never;
    url: '/api/v1/workbooks/{workbook_id}';
};

export type GetWorkbookErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetWorkbookError = GetWorkbookErrors[keyof GetWorkbookErrors];

export type GetWorkbookResponses = {
    /**
     * Successful Response
     */
    200: Workbook;
};

export type GetWorkbookResponse = GetWorkbookResponses[keyof GetWorkbookResponses];

export type AttachDatapointToWorkbookData = {
    body: WorkbookEntry;
    path: {
        /**
         * Workbook Id
         */
        workbook_id: number;
    };
    query?: never;
    url: '/api/v1/workbooks/{workbook_id}';
};

export type AttachDatapointToWorkbookErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type AttachDatapointToWorkbookError = AttachDatapointToWorkbookErrors[keyof AttachDatapointToWorkbookErrors];

export type AttachDatapointToWorkbookResponses = {
    /**
     * Successful Response
     */
    201: WorkbookEntry;
};

export type AttachDatapointToWorkbookResponse = AttachDatapointToWorkbookResponses[keyof AttachDatapointToWorkbookResponses];

export type EditWorkbookEntryData = {
    body: WorkbookEntry;
    path: {
        /**
         * Workbook Id
         */
        workbook_id: number;
    };
    query?: never;
    url: '/api/v1/workbooks/{workbook_id}';
};

export type EditWorkbookEntryErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type EditWorkbookEntryError = EditWorkbookEntryErrors[keyof EditWorkbookEntryErrors];

export type EditWorkbookEntryResponses = {
    /**
     * Successful Response
     */
    200: WorkbookEntry;
};

export type EditWorkbookEntryResponse = EditWorkbookEntryResponses[keyof EditWorkbookEntryResponses];

export type UpsertWorkbookData = {
    body: WorkbookWithDatapoints;
    path?: never;
    query?: never;
    url: '/api/v1/workbooks';
};

export type UpsertWorkbookErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UpsertWorkbookError = UpsertWorkbookErrors[keyof UpsertWorkbookErrors];

export type UpsertWorkbookResponses = {
    /**
     * Successful Response
     */
    201: Workbook;
};

export type UpsertWorkbookResponse = UpsertWorkbookResponses[keyof UpsertWorkbookResponses];

export type GetWorkbookGraphData = {
    body?: never;
    path: {
        /**
         * Workbook Id
         */
        workbook_id: number;
    };
    query?: {
        /**
         * Additional Ids
         */
        additional_ids?: Array<string | number>;
        /**
         * Exclude All Domain Bound Nodes
         */
        exclude_all_domain_bound_nodes?: boolean;
    };
    url: '/api/v1/workbooks/{workbook_id}/graph';
};

export type GetWorkbookGraphErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetWorkbookGraphError = GetWorkbookGraphErrors[keyof GetWorkbookGraphErrors];

export type GetWorkbookGraphResponses = {
    /**
     * Successful Response
     */
    200: PsiGraph;
};

export type GetWorkbookGraphResponse = GetWorkbookGraphResponses[keyof GetWorkbookGraphResponses];

export type HealthCheckHealthyGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/healthy';
};

export type HealthCheckHealthyGetResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type DeliberateErrorKaboomGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/kaboom';
};

export type DeliberateErrorKaboomGetResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};
